export interface TrackingEntry {
  dashboard: string;
  page: string;
}

export const PATH_TO_TRACKING: Record<string, TrackingEntry> = {
  // Auth / error pages
  "/login": { dashboard: "Login", page: "Login" },
  "/logout": { dashboard: "Login", page: "Logout" },
  "/sign_up": { dashboard: "Login", page: "Sign Up" },
  "/forgotten_password": { dashboard: "Login", page: "Forgotten Password" },
  "/set-password": { dashboard: "Login", page: "Set Password" },
  "/welcome": { dashboard: "Login", page: "Welcome" },
  "/403": { dashboard: "Error", page: "Access Denied" },
  "/404": { dashboard: "Error", page: "Not Found" },
  "/invalid_token": { dashboard: "Error", page: "Invalid Token" },

  // CEDAR Home Restructure - new shell pages
  "/home": { dashboard: "Home", page: "Home" },
  "/dashboards": { dashboard: "Dashboards", page: "Dashboards" },
  "/favourites": { dashboard: "Favourites", page: "Favourites" },
  "/analytics": { dashboard: "Analytics", page: "Analytics" },
  "/settings": { dashboard: "Settings", page: "Settings" },
  "/faq": { dashboard: "FAQ", page: "FAQ" },
  // Formerly "/global_ms_sales/pdf_page" - see App.tsx's own comment on this route.
  "/faq/link_google_account": { dashboard: "FAQ", page: "Link Google Account" },
  "/alerts": { dashboard: "Alerts", page: "Alerts" },
  "/archived": { dashboard: "Archived", page: "Archived" },
  "/admin": { dashboard: "Admin", page: "Admin" },

  // SEO / Search
  "/seo_dashboard": { dashboard: "SEO Overview", page: "SEO Overview" },
  "/seo_dashboard/search_interest_report": { dashboard: "Search Interest", page: "Search Interest" },
  "/seo_dashboard/geo_reporting": { dashboard: "GEO Reporting", page: "GEO Reporting" },

  // Brand Performance — page overridden dynamically in BrandPerformanceDashboard
  "/brand_performance": { dashboard: "Brand Performance", page: "volume" },

  // VOC
  "/voc/customer_journey_voc": { dashboard: "Customer Journey VOC", page: "Customer Journey VOC" },
  "/voc/website": { dashboard: "VOC Website", page: "VOC Website" },
  "/voc/quick_voc_sales": { dashboard: "Quick VOC Sales", page: "Quick VOC Sales" },
  "/voc/quick_voc_after_sales": { dashboard: "Quick VOC After Sales", page: "Quick VOC After Sales" },
  "/voc/cec_voc": { dashboard: "CEC VOC", page: "CEC VOC" },
  "/voc/voc_rsa": { dashboard: "VOC RSA", page: "VOC RSA" },
  "/voc/google_rating": { dashboard: "VOC Google Rating", page: "VOC Google Rating" },
  "/voc/some": { dashboard: "VOC SoMe", page: "VOC SoMe" },

  // Online CE Performance
  "/digital_performance": { dashboard: "OCE", page: "OCE" },
  "/cpo_digital_performance": { dashboard: "CPO", page: "CPO" },
  "/oce_digital_trend": { dashboard: "OCE", page: "OCE Digital Trend" },

  // Journey Excellence
  "/journey_excellence/market_performance_summary": {
    dashboard: "Journey Excellence - Market Performance Summary",
    page: "Journey Excellence - Market Performance Summary",
  },
  "/journey_excellence/deep_dive": { dashboard: "Journey Excellence - Deep Dive", page: "Journey Excellence - Deep Dive" },

  // Ecommerce
  "/ecommerce": { dashboard: "Ecommerce", page: "Ecommerce" },
  "/cpo_operational": { dashboard: "Used Cars", page: "Used Cars" },

  // Product Marketing Optimization
  "/product_marketing_optimization": { dashboard: "Product Marketing Optimization", page: "Product Marketing Optimization" },
  "/product_marketing_optimization/dfp_dashboard": { dashboard: "Product Marketing Optimization", page: "Drivers for flash performance" },

  // USE Ownership
  "/use_ownership/overview": { dashboard: "Use Ownership", page: "User Ownership Overview" },
  "/use_ownership/online_account_and_engagement": { dashboard: "Use Ownership", page: "Online Account & Engagement" },
  "/use_ownership/service_lead": { dashboard: "Use Ownership", page: "Service Lead" },
  "/use_ownership/self_service": { dashboard: "Use Ownership", page: "Self Service" },

  // CCS Vital Signs (Domo)
  "/ccs_vital_signs/domo": { dashboard: "CCS Vital Signs (Domo)", page: "CCS Vital Signs (Domo)" },
  "/ccs_vital_signs/domoscreen": { dashboard: "CCS Vital Signs (Domo)", page: "CCS Vital Signs (Domo)" },

  // CCS Monetization
  "/ccs_vital_signs/ccs_monetization": { dashboard: "CCS Monetization", page: "CCS Monetization" },
  "/ccs_vital_signs/ccs_monetization/stv_subscriptions": { dashboard: "CCS Monetization", page: "CCS Monetization - STV Subscriptions" },

  // CCS Vital Signs (archived)
  "/ccs_vital_signs/ccs_cockpit": { dashboard: "CCS (archived)", page: "CCS Vital Signs (archived)" },
  "/ccs_vital_signs/app_ratings": { dashboard: "CCS (archived)", page: "CCS App Ratings (archived)" },
  "/ccs_vital_signs/app_ratings_breakdown": { dashboard: "CCS (archived)", page: "CCS App Ratings Breakdown (archived)" },
  "/ccs_vital_signs/data_quality": { dashboard: "CCS (archived)", page: "CCS Data Quality (archived)" },
  "/ccs_vital_signs/ccs_journey": { dashboard: "CCS (archived)", page: "CCS Journey (archived)" },
  "/ccs_vital_signs/ccs_journey/europe_activation": { dashboard: "CCS (archived)", page: "CCS Europe Activation (archived)" },
  "/ccs_vital_signs/ccs_journey/uae_activation": { dashboard: "CCS (archived)", page: "CCS UAE Activation (archived)" },
  "/ccs_vital_signs/ccs_journey/asean_activation": { dashboard: "CCS (archived)", page: "CCS ASEAN Activation (archived)" },
  "/ccs_vital_signs/top_flop": { dashboard: "CCS (archived)", page: "Top/Flop (archived)" },
  "/ccs_vital_signs/ccs_analysis": { dashboard: "CCS (archived)", page: "CCS Analysis (archived)" },

  // G-M&S Re:Ignite Control Tower
  "/global_ms_sales/ignitems": { dashboard: "Global M&S - Report Overview", page: "Global M&S - Report Overview" },
  "/global_ms_sales/tier_one": { dashboard: "Global M&S - Sales & Inventory", page: "Global M&S - Sales & Inventory" },
  "/global_ms_sales/tier_two": {
    dashboard: "Global M&S - Marketing & Leads Generation",
    page: "Global M&S - Marketing & Leads Generation",
  },
  "/global_ms_sales/tier_three": { dashboard: "Global M&S - Marketing Performance", page: "Global M&S - Marketing Performance" },
  "/global_ms_sales/handbook_pdf_page": { dashboard: "Global M&S - Handbook PDF Page", page: "Global M&S - Handbook PDF Page" },

  // Executive Summary / DIS
  "/executive_summary/dis": { dashboard: "DIS Overview", page: "DIS Overview" },
  "/executive_summary/product_performance": { dashboard: "Product Performance", page: "Product Performance" },
  "/executive_summary/product_performance_deep_dive": {
    dashboard: "Product Performance - Deep Dive",
    page: "Product Performance - Deep Dive",
  },
  "/purchase_funnel_report": { dashboard: "DIS Deep-Dive", page: "DIS Deep-Dive" },
  "/purchase_funnel_report/msrp": { dashboard: "DIS Deep-Dive", page: "DIS - MSRP" },
  "/purchase_funnel": { dashboard: "DIS Deep-Dive", page: "Purchase Funnel" },
  "/purchase_funnel/diagnostic": { dashboard: "DIS Deep-Dive", page: "Purchase Funnel Diagnostic" },

  // Lead Management Report
  "/lead_management_report/introduction": { dashboard: "Lead Management Report", page: "Introduction" },
  "/lead_management_report/high_level": { dashboard: "Lead Management Report", page: "High Level" },
  "/lead_management_report/detail_level_one": { dashboard: "Lead Management Report", page: "Detail Level 1" },
  "/lead_management_report/detail_level_two": { dashboard: "Lead Management Report", page: "Detail Level 2" },

  // C-19 Mobility Restrictions (archived)
  "/mobility_report": { dashboard: "C-19 Mobility Restrictions", page: "Mobility Report" },
  "/mobility_report/insights": { dashboard: "C-19 Mobility Restrictions", page: "Mobility Insights Report" },

  // Digital User Experience (archived)
  "/digital_user_experience": { dashboard: "Digital User Experience", page: "Digital User Experience" },
  "/digital_user_experience_core_models": { dashboard: "Digital User Experience", page: "Digital User Experience - Core Models" },

  // Online to Physical (archived)
  "/online_to_physical": { dashboard: "Online To Physical", page: "Online To Physical" },

  // ARIYA experience monitor (archived)
  "/ariya/monitor": { dashboard: "Ariya", page: "Ariya Monitor" },
  "/ariya/experience": { dashboard: "Ariya", page: "Ariya Experience Insights" },
  "/ariya/handraisers": { dashboard: "Ariya", page: "Ariya Handraisers Insights" },
  "/ariya/handraisers/market-split": { dashboard: "Ariya", page: "Ariya Handraisers Insights - Market split" },
  "/ariya/preorder": { dashboard: "Ariya", page: "Ariya Preorder" },
  "/ariya/preorder/japan": { dashboard: "Ariya", page: "Ariya Preorder - Japan" },
  "/ariya/preorder/norway": { dashboard: "Ariya", page: "Ariya Preorder - Norway" },
  "/ariya/preorder/netherlands": { dashboard: "Ariya", page: "Ariya Preorder - Netherlands" },
  "/ariya/preorder/united-states": { dashboard: "Ariya", page: "Ariya Preorder - USA" },
  "/ariya/preorder/united-kingdom": { dashboard: "Ariya", page: "Ariya Preorder - UK" },
  "/ariya/preorder/canada": { dashboard: "Ariya", page: "Ariya Preorder - Canada" },
  "/ariya/preorder/france": { dashboard: "Ariya", page: "Ariya Preorder - France" },
  "/ariya/preorder/germany": { dashboard: "Ariya", page: "Ariya Preorder - Germany" },
  "/ariya/preorder/italy": { dashboard: "Ariya", page: "Ariya Preorder - Italy" },
  "/ariya/preorder/sweden": { dashboard: "Ariya", page: "Ariya Preorder - Sweden" },
  "/ariya/preorder/belgium": { dashboard: "Ariya", page: "Ariya Preorder - Belgium" },

  // MTM metrics that matter (archived)
  "/mtm_metrics": { dashboard: "MTM", page: "MTM" },

  // Marketing Investment Dashboard / Midas (archived)
  "/midas": { dashboard: "Midas", page: "Midas" },
  "/midas/fmi_run_rate": { dashboard: "Midas", page: "FMI run rate" },
  "/midas/fmi_by_model": { dashboard: "Midas", page: "FMI by model" },
  "/midas/media_mix": { dashboard: "Midas", page: "Media mix" },
  "/midas/mtp_category": { dashboard: "Midas", page: "MTP category" },
  "/midas/strategic_dealer_support": { dashboard: "Midas", page: "Strategic - Dealer support" },
  "/midas/strategic_ce": { dashboard: "Midas", page: "Strategic CE" },
  "/midas/fixed": { dashboard: "Midas", page: "Fixed" },
  "/midas/spend_vs_traffic": { dashboard: "Midas", page: "Spend vs Traffic" },

  // DMEO (archived)
  "/dmeo": { dashboard: "DMEO", page: "DMEO" },
  "/dmeo/landing-page-performance": { dashboard: "DMEO", page: "Landing Page Performance" },

  // Search Interest (archived)
  "/search_interest": { dashboard: "Search Interest (archived)", page: "Search Interest (archived)" },

  // Trim Mix Analysis
  "/trim_mix_report": { dashboard: "Trim Mix Analysis", page: "Trim Mix Analysis" },

  // Product Performance (archived)
  "/product_performance": { dashboard: "Product Performance", page: "Product Performance" },

  // Analytics Tools
  "/streamlit/abt_data_query": { dashboard: "Streamlit - MI Query Tool", page: "Streamlit - MI Query Tool" },
  "/streamlit/clv": { dashboard: "Streamlit - CLV Dashboard", page: "Streamlit - CLV Dashboard" },
  "/streamlit/correspondence_mapping": { dashboard: "Streamlit - Correspondence Mapping", page: "Streamlit - Correspondence Mapping" },
  "/streamlit/pricing_project": { dashboard: "Streamlit - Pricing Project", page: "Streamlit - Pricing Project" },
  "/streamlit/serious_buyer": { dashboard: "Streamlit - Serious Buyer", page: "Streamlit - Serious Buyer" },
  "/streamlit/verbatim_analysis": { dashboard: "Streamlit - Verbatim Analysis", page: "Streamlit - Verbatim Analysis" },
  "/streamlit/visit_to_lead_tool": { dashboard: "Streamlit - Visit To Lead", page: "Streamlit - Visit To Lead" },

  // Configurators (analytics tools)
  "/beta/configurator-g5": { dashboard: "Configurator Explorer G5", page: "Configurator Explorer G5" },
  "/beta/car_configurator": { dashboard: "Configurator Explorer JP", page: "Configurator Explorer JP" },
  "/beta/configurator-nibu": { dashboard: "Configurator Explorer NIBU", page: "Configurator Explorer NIBU" },
  "/beta/cxo_experiment": { dashboard: "CXO Experiment Library", page: "CXO Experiment Library" },

  // Profile / Info
  "/user_profile": { dashboard: "Profile", page: "User profile" },
  "/dashboard_info": { dashboard: "INFO", page: "Dashboard Info" },
  "/release_notes": { dashboard: "INFO", page: "Release Notes" },
  "/data_info": { dashboard: "INFO", page: "Data Info" },
};
